module.exports = __webpack_public_path__ + "static/media/bg_setting1363fac689139eb6451ae8649e5162e8.webp";